<div [class]="'space-menu ' + classes" [style.left.px]="left" [style.top.px]="top">
  <div class="tooltip-content">
    <span *ngIf="title" class="tooltip-title">{{ title }}</span>
    <div class="space-user" *ngFor="let u of users | slice: 0:numberOfUsersToShow()">
      <app-badged-avatar-or-icon
        *ngIf="useIconBadgedAvatarsComponent; else profilePhoto"
        class="cml-4"
        [showAvatar]="u.showAvatar"
        [showBadge]="u.showBadge"
        [iconConfig]="iconConfig"
        [isUser]="!!u"
        [profileImage]="u.profile_image"
        [userRole]="u.role"
        [userEmail]="u.email"
        [userName]="u.name"
        [avatarWidth]="26"
      ></app-badged-avatar-or-icon>
      <ng-template #profilePhoto>
        <app-profile-photo
          class="cursor-default cml-4"
          [user]="u"
          [width]="26"
          [fontSize]="14"
          [isClickEnabled]="false"
        >
        </app-profile-photo>
      </ng-template>
      <div class="space-user-name">
        {{
          useIconBadgedAvatarsComponent && u.altName
            ? u.altName || ''
            : u.name ?? (u.fullName ?? '')
        }}
      </div>
    </div>
    <div *ngIf="numberOfUsersCondition()">
      <button
        mat-flat-button
        color="secondary"
        class="more-btn"
        (click)="showMoreUsers = true; $event.stopPropagation()"
        data-name="space-manager-space-participants-more"
      >
        <span>{{ users.length - defaultNumberOfUsers }} {{ 'more' | translate }}...</span>
      </button>
    </div>
  </div>
</div>
